import darkTheme from './dark-theme';
import lightTheme from './light-theme';

export default {
	dark: darkTheme,
	light: lightTheme
};
